import { Utilitaries } from "../../../business";
import { sendHttpRequest } from "../../../components/http.request";

export const getMenus = async (pagination, filter, sorter) => {
    const formData = new FormData();

    formData.append("accao", "lista");
    formData.append("pagina", pagination.page);
    formData.append("resultados_pagina", pagination.perPage);

    Object.entries(filter).forEach(([key, val]) => {
        formData.append(`filtro_${key}`, val);
    });

    if (sorter && sorter.sorterBy && sorter.sorterOrder) {
        formData.append(`ordenacao_${sorter.sorterBy}`, sorter.sorterOrder === "ascend" ? "ASC" : "DESC");
    }

    return sendHttpRequest("POST", "/Gestor/geremenus.php", formData).then((jsonResponse) => {
        if (!jsonResponse.erro && jsonResponse && jsonResponse["@attributes"]) {
            return {
                list: Utilitaries.toArray(jsonResponse.linha),
                metadata: jsonResponse["@attributes"],
            };
        }

        return false;
    });
};

export const saveAutorizations = async (requestBody) => {
    const formData = new FormData();
    Object.entries(requestBody).forEach(([key, value]) => {
        formData.append(key, value);
    });
    return await sendHttpRequest("POST", "/Gestor/geremenus.php", formData).then((jsonResponse) => {
        if (jsonResponse.sucesso) return true;
        else return false;
    });
};

export async function toggleMenuStatus(idmenu, active) {
    const formData = new FormData();

    formData.append("accao", "activa_inativa");
    formData.append("idmenu", idmenu);
    formData.append("estado", active ? "ATIVAR" : "INATIVAR");

    return sendHttpRequest("POST", "/Gestor/geremenus.php", formData).then((jsonResponse) => {
        return jsonResponse;
    });
}

export async function getMenusNotInactive() {
    const formData = new FormData();
    formData.append("accao", "menus_nao_inativar");
    return sendHttpRequest("POST", "/Gestor/geremenus.php", formData).then((jsonResponse) => {
        if (!jsonResponse.erro && jsonResponse) {
            return Utilitaries.toArray(jsonResponse.linha);
        }

        return false;
    });
}
